{
    "coordinates": [
        41.80456844918382,
        15.482990432372304
    ],
    "tooltip": "Gargano",
    "title": "Gargano Island (Mikrotia Fauna)",
    "country": "Italy",
    "period": "Neogene",
    "alt": "TODO"
}
